import { privateClient } from './client';

const fetchPlans = sessionId => privateClient(sessionId).get(`/v1/plans`);

const fetchPlansV2 = (sessionId, headers) => privateClient(sessionId).get(`/v2/plans`, headers);

export { fetchPlans, fetchPlansV2 };
